module.exports = __webpack_public_path__ + "img/video-cover.a6f14902.png";